import dayjs from 'dayjs';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export default async function getLots(userDetails, callback) {
	let coBrokerId;

	if (userDetails.userType === 'cobroker') {
		await firebase
			.database()
			.ref('/kavtek_coBrokers/' + PROJECT_CODE.projectCode)
			.orderByChild('userId')
			.equalTo(userDetails.uid)
			.once('value', async (snapshot) => {
				let coBrokerObj = snapshot.val();
				if (coBrokerObj) {
					let coBrokerKeys = Object.keys(coBrokerObj);
					if (coBrokerKeys.length > 0) {
						coBrokerId = coBrokerKeys[0];
					}
				}
			});
	}

	let lotRef = firebase
		.database()
		.ref('/kavtek_lots/' + PROJECT_CODE.projectCode);

	firebase
		.database()
		.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			let lotListArr = [];
			let lotAssignment;
			let availabilityObj;
			let coBrokerAssignedLots = [];

			snapshot.forEach((lot) => {
				let lotName = lot.val().lotId;
				let availabilityValue = lot.val()?.available;
				let coBrokerValue = lot.val()?.coBroker;
				let assignedSalesAgentValue = lot.val()?.assignedSalesAgent;
				let assignedCoBrokerValue = lot.val()?.assignedCoBroker;
				let closingDateValue = lot.val()?.closingDate;
				let lotPrice = lot.val()?.lotPrice;
				let premiumDescription = lot.val()?.premiumDescription;
				let lotSize = lot.val()?.lotSize;
				let lotSizeType = lot.val()?.lotSizeType;
				let buildings = lot.val()?.buildings;
				let pricing = lot.val()?.pricing;

				lotAssignment = {
					lot: lotName,
					availability: availabilityValue,
					assignedSalesAgent: assignedSalesAgentValue,
					assignedCoBroker: assignedCoBrokerValue,
					closingDate: closingDateValue,
					lotPrice: lotPrice,
					premiumDescription: premiumDescription,
					lotSize: lotSize,
					lotSizeType: lotSizeType,
					buildings: buildings,
					pricing: pricing,
				};

				if (dayjs(closingDateValue).isBefore(dayjs(new Date()))) {
					console.log('Is before', lotName);

					let lotRef = firebase
						.database()
						.ref(
							'/kavtek_lots/' +
								PROJECT_CODE.projectCode +
								'/' +
								lotName
						);

					lotRef.update({
						available: 'hold',
					});
				}

				availabilityObj = {
					...availabilityObj,
					[`lot` + lotName]: availabilityValue,
				};

				lotListArr.push(lotAssignment);

				if (coBrokerId && assignedCoBrokerValue === coBrokerId) {
					coBrokerAssignedLots.push(lotName);
				}
			});
			callback(lotListArr, availabilityObj, coBrokerAssignedLots);
		});
}
